import React from "react";
import getConfig from "next/config";

import serializeSchema from "@lib/structuredData";

const {
  publicRuntimeConfig: {
    settings: { baseUrl },
  },
} = getConfig();

const BreadcrumbSchema = ({ breadcrumbData, currentPath }) => {
  // Do not include home page
  // Do not include pages without parent
  if (breadcrumbData && breadcrumbData.length > 1) {
    const itemListElement = breadcrumbData.map((breadcrumb, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: breadcrumb.name,
      item:
        breadcrumb.level != 99
          ? `${baseUrl}/${breadcrumb.url_key}${breadcrumb.url_suffix || ""}`
          : `${baseUrl}${currentPath}`,
    }));

    const schema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement,
    };

    return (
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: serializeSchema(schema) }}
      />
    );
  }

  return null;
};

export default BreadcrumbSchema;
